import React, { PureComponent } from 'react';
import { ImageService } from '../../../main/services/ImageService/ImageService';

import { ROLE_IDS_TO_HUMAN_READABLE } from '../../support/accessControlConstants';
import { getResourceText } from '../../support/utils/accessControlHelpers';
import { ACCESS_FEATURE } from '../../../../../shared/constants';
import type { UiRoleId } from '../../../main/types/accessControlTypes';
import { type AccessResource } from '../../../main/types/accessControlTypes';
import type { AccessFeature } from '../../../../../shared/types';

const ACCESS_FEATURE_TEXT = {
  [ACCESS_FEATURE.TEMPLATE_ONLY]: {
    needed: 'creating and editing links',
    current: 'template-only link creation and editing',
  },
};

interface CommonProps {
  loading?: boolean;
  role?: UiRoleId;
}

interface PropsA extends CommonProps {
  accessResources: AccessResource[];
  accessFeature?: never;
}

interface PropsB extends CommonProps {
  accessResources?: never;
  accessFeature: AccessFeature;
}

type Props = PropsA | PropsB;

export default class ForbiddenView extends PureComponent<Props> {
  getAccessNeededText = () => {
    if (this.props.accessFeature) {
      return ACCESS_FEATURE_TEXT[this.props.accessFeature]?.needed;
    }
    return getResourceText(this.props.accessResources);
  };

  getCurrentAccessText = () => {
    const customRoleText = 'Custom';
    if (this.props.accessFeature) {
      return ACCESS_FEATURE_TEXT[this.props.accessFeature]?.current;
    }
    return this.props.role ? ROLE_IDS_TO_HUMAN_READABLE[this.props.role] || customRoleText : customRoleText;
  };

  render() {
    const accessNeeded = this.getAccessNeededText();
    const currentAccess = this.getCurrentAccessText();
    return (
      <div className="flex-layout__screen">
        <div data-testid="forbidden-view__container" className="forbidden-view__container">
          <img className="forbidden-view__image" src={ImageService.getImageUrl('/static/images/locked.svg')} />
          <div className="forbidden-view__title">You do not have access to this page</div>
          {!this.props.loading && (
            <div>
              <span>{`You need access to `}</span>
              <span className="h_fw-500">{accessNeeded}</span>
              <span>{` to see this page. Currently you have `}</span>
              <span className="h_fw-500 h_c-info">{currentAccess}</span>
              <span>{` access to this account, which does not include these permissions. Please contact your administrator for access or more information.`}</span>
            </div>
          )}
        </div>
      </div>
    );
  }
}
